import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getExcerciseChoiceConfig, isEmpty, newLineParser } from "../utils";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import { Choices } from '../enums';
import { CardActionArea } from '@mui/material';
import { Box } from '@mui/material';
import Chip from '@mui/material/Chip';
import TranscriptionVideo from '../components/TranscriptionVideo';
import { getExcerciseText } from '../utils';
import TextField from '@mui/material/TextField';


export default function IntroductionExcercisePage({ pageId, excerciseId, setChoice }) {

    let feedbackTxt = getExcerciseChoiceConfig(pageId, excerciseId, Choices.A)['feedback'];
    

    const showIntroText = getExcerciseText(pageId, excerciseId, "inleiding") ? true : false;
    const IntroText = () => (
        <div>
            <Typography variant="h5" gutterBottom>
                Inleiding
            </Typography>

            <Typography variant="body2" gutterBottom>
                {getExcerciseText(pageId, excerciseId, "inleiding")}
            </Typography>
            <br />
        </div>
    );

    let transVideoSrc = getExcerciseText(pageId, excerciseId, "inleiding_film");

    let vraag_text = newLineParser(getExcerciseText(pageId, excerciseId, "vraag_text"));
    //Oefening 4, 5 & 6 hebben twee invulvelden
    if(excerciseId == 3 || excerciseId == 4 || excerciseId == 5) {
        vraag_text = [
            vraag_text[0],
            <TextField
                key={"invulveld2"+excerciseId}
                id="outlined-multiline-static"
                label="Geef hier je antwoord"
                multiline
                fullWidth
                minRows={2}
            />,
            vraag_text[1],
        ]
    }
    let ChoiceText = () => (
        <div>
            <Typography variant="h5" gutterBottom>
                Vraag {excerciseId + 1}
            </Typography>

            <Typography variant="body2" gutterBottom>
                {vraag_text}
            </Typography>

        </div>
    );

    return (
        <React.Fragment>

            {showIntroText ? <IntroText /> : null}

            <TranscriptionVideo src={transVideoSrc} transcription={getExcerciseText(pageId, excerciseId, "inleiding_film_transcriptie")} />

            <ChoiceText />

            <TextField
                key={"invulveld2"+excerciseId}
                id="outlined-multiline-static"
                label="Geef hier je antwoord"
                multiline
                fullWidth
                minRows={2}
            />


            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                    variant="contained"
                    onClick={() => setChoice(Choices.A)}
                    sx={{ mt: 3, ml: 1 }}
                >
                    {isEmpty(feedbackTxt) ? "Ga naar volgende oefening" : "Volgende"}
                </Button>
            </Box>

        </React.Fragment>
    );
}
